import React, {Component} from 'react';
import {reduxForm, SubmissionError} from 'redux-form';
import {Button, Label} from 'reactstrap';
import {authActions, ff, Form, FormActions, FormBody, Icon, Loader} from '@mc/mc-legacy';
import MarbesAuthApi from 'mc/lib/api/gen/reactcore/MarbesAuthApi';
import './CustomLoginForm.scss';

const loginForm = typeof appConfig?.loginForm === 'undefined' ? true : appConfig?.loginForm;
const loginSso = typeof appConfig?.loginSso === 'undefined' ? true : appConfig?.loginSso;
const loginNtlm = typeof appConfig?.loginNtlm === 'undefined' ? true : appConfig?.loginNtlm;

/**
 * Klientská validace.
 * @param formData data formuláře
 * @return {{}}
 */
const validateNtlmLogin = formData => {
    const errors: any = {};

    if (!formData.username) {
        errors.username = 'Uživatelské jméno je povinné';
    }

    if (!formData.password) {
        // errors.password = "Heslo jméno je povinné"; // TODO check active profiles
    }

    return errors;
};

class NtlmLogin extends React.Component<any, any> {
    static formName = 'ntlmLoginForm';
    static redirectNtlmLogin = () => {
        window.location.href =
            ((window as any).serverContextPath as string) +
            '/api/auth/ntlm?redir=' +
            encodeURIComponent(window.location.href);
    };
    static isWindows = () => {
        const winPlatforms = ['Win32', 'Win64', 'Windows'];
        return winPlatforms.indexOf(window.navigator.platform) > -1;
    };

    constructor(props) {
        super(props);
        this.state = {
            ntlmFetched: false,
            canUseNtlm: true,
        };
    }

    componentDidMount() {
        if (!this.state.ntlmFetched) {
            MarbesAuthApi.canUseNtlm().then(canUseNtlm => {
                this.setState({
                    ntlmFetched: true,
                    canUseNtlm: canUseNtlm,
                });
            });
        }
        if (!loginForm && !loginNtlm && loginSso && !this.props.skipAutoSso) {
            setTimeout(this.redirectSaml, 300);
        }
    }

    redirectSaml = () => {
        //window.location.pathname = window.location.pathname + '/saml';
        window.location.href = ((window as any).moduleContextPath as string) + '/login/saml';
    }

    renderCustom = () => {
        const {canUseNtlm} = this.state;
        return <>
            {NtlmLogin.isWindows() && loginNtlm && canUseNtlm && (
                <Button className="mr-1" type="button" onClick={NtlmLogin.redirectNtlmLogin}>
                    <Icon icon="windows"/> Převzít přihlášení z Windows
                </Button>
            )}
            {loginSso && <Button className="mr-1" type="button" onClick={this.redirectSaml}>
                Přihlásit přes SSO
            </Button>}
        </>
    }

    renderNone = () => {
        return <>
            {!loginSso && !loginForm && !loginNtlm && <span className="mr-1">
                Není zapnut žádný způsob přihlašování
            </span>}
        </>
    }

    render() {
        const {onClose, handleSubmit, submitting, error} = this.props;
        const {ntlmFetched, canUseNtlm} = this.state;
        const disabled = submitting;
        const commons = {
            disabled,
        };

        if (!ntlmFetched) {
            return <Loader/>;
        }

        if (loginForm) {
            return (
                <Form className="custom-login-form col-12" onSubmit={handleSubmit} horizontal>
                    <FormBody>
                        <ff.String
                            label="Uživatelské jméno"
                            name="username"
                            autoComplete="username"
                            {...commons}
                        />
                        <ff.String
                            label="Heslo"
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            {...commons}
                        />
                    </FormBody>
                    {error && (
                        <h5
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Label className="text-danger">{error}</Label>
                        </h5>
                    )}
                    <FormActions
                        onClose={onClose}
                        disabled={disabled}
                        submitButton={'Přihlásit'}
                    >
                        {this.renderCustom()}
                    </FormActions>
                </Form>
            );
        } else {
            return <div className="text-center">
                {this.renderCustom()}
                {this.renderNone()}
            </div>
        }
    }
}

const NtlmLoginForm = reduxForm({
    form: NtlmLogin.formName,
    validate: validateNtlmLogin,
})(NtlmLogin as any);

class CustomLoginForm extends Component<any, any> {
    handleNtlmLogin = (credentials: any) => {
        return MarbesAuthApi.login(credentials).then(data => {
            if (data.auth) {
                // je přihlášen
                return data;
            } else {
                // chyba, zobrazíme ji uživateli
                throw new SubmissionError({
                    _error: 'Chybně zadané heslo nebo uživatelské jméno',
                });
            }
        });
    };

    render() {
        return (
            <NtlmLoginForm
                onSubmit={this.handleNtlmLogin}
                onSubmitSuccess={(result, dispatch) => {
                    dispatch(authActions.loginSucccess(result));
                }}
                skipAutoSso={this.props.skipAutoSso}
            />
        );
    }
}

export default CustomLoginForm;
